import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectNotificationsStatusFragment = { __typename?: 'Project', id: string, notificationsEnabled?: boolean | null };

export const ProjectNotificationsStatus = /*#__PURE__*/ gql`
    fragment ProjectNotificationsStatus on Project {
  id
  notificationsEnabled
}
    ` as unknown as DocumentNode<ProjectNotificationsStatusFragment, unknown>;

        

        
export const useProjectNotificationsStatusFragment = (
  input: string | Omit<UseFragmentOptions<ProjectNotificationsStatusFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectNotificationsStatusFragment>({
    fragment: ProjectNotificationsStatus,
    fragmentName: 'ProjectNotificationsStatus',
    ...options,
  });
};
  
        